// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__15irF","header":"ReportDetails_header__3k5_J","title":"ReportDetails_title__levXa","left":"ReportDetails_left__3Aq89"};